
import Vue from 'vue';
import Vuex, { Store } from 'vuex';

import { RootStore } from './@types/store';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { authorization } from './authorization';
import { localization } from './localization';
import { loggedUser } from './loggedUser';
import { pageManager } from './pageManager';
import { pages } from './pages';
import { external } from './external';

Vue.use(Vuex);

export const store: Store<RootStore> = new Vuex.Store({
	state: {
		loggedUser,
	} as any,
	actions,
	getters,
	mutations,
	modules: {
		authorization,
		localization,
		pageManager,
		pages,
		external,
	},
});
